/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyTaskType,
    ReadOnlyTaskTypeFromJSON,
    ReadOnlyTaskTypeFromJSONTyped,
    ReadOnlyTaskTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20016
 */
export interface InlineResponse20016 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20016
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20016
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20016
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyTaskType>}
     * @memberof InlineResponse20016
     */
    results: Array<ReadOnlyTaskType>;
}

export function InlineResponse20016FromJSON(json: any): InlineResponse20016 {
    return InlineResponse20016FromJSONTyped(json, false);
}

export function InlineResponse20016FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20016 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyTaskTypeFromJSON)),
    };
}

export function InlineResponse20016ToJSON(value?: InlineResponse20016 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyTaskTypeToJSON)),
    };
}


